import React from 'react';
import { StructuredText } from '~/components';
import { useEscapeKey } from '../hooks';

interface AnswerComparisonModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentAnswer: any; // The current question's answer document
  matchedAnswer: any; // The best match question's answer document
  currentQuestionId: string;
  matchedQuestionId: string;
  questionText: string;
}

export const AnswerComparisonModal = ({
  isOpen,
  onClose,
  currentAnswer,
  matchedAnswer,
  currentQuestionId,
  matchedQuestionId,
  questionText,
}: AnswerComparisonModalProps) => {
  // Handle Escape key to close modal
  useEscapeKey(onClose, isOpen);

  if (!isOpen) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-7xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold flex items-center gap-2">
            Answer Comparison
            <span className="text-sm text-gray-500 font-mono">{currentQuestionId}</span>
          </h3>
          <button
            className="btn btn-sm btn-circle btn-ghost"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {/* Question Text */}
        <div className="mb-2">
          <p className="text-sm text-gray-600 bg-gray-50 p-4 rounded border">
            {questionText || 'No question text available'}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Matched Answer */}
          <div className="border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-semibold text-green-600">Matched Answer</h4>
              <span className="text-sm text-gray-500 font-mono">{matchedQuestionId}</span>
            </div>
            <div className="prose max-w-none">
              {matchedAnswer ? (
                <StructuredText document={matchedAnswer} />
              ) : (
                <p className="text-gray-500 italic">No answer available</p>
              )}
            </div>
          </div>
          {/* Current Answer */}
          <div className="border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-semibold text-blue-600">Current Answer</h4>
            </div>
            <div className="prose max-w-none">
              {currentAnswer ? (
                <StructuredText document={currentAnswer} />
              ) : (
                <p className="text-gray-500 italic">No answer available</p>
              )}
            </div>
          </div>
        </div>

        <div className="modal-action">
          <button className="btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};
